import { Paper, LoadingOverlay, Group, Text, Button, Table, Badge, ActionIcon } from '@mantine/core';
import { IconPlus, IconEdit, IconTrash } from '@tabler/icons-react';

export default function AppsSettingsSection({
  loading,
  activeTab,
  apps,
  fetchApps,
  openNewApp,
  openEditApp,
  handleDeleteApp,
}) {
  return (
    <Paper withBorder p="md" radius="md" mt="xs" pos="relative">
      <LoadingOverlay visible={loading && activeTab === 'apps'} overlayProps={{ radius: 'sm', blur: 2 }} />

      <Group justify="space-between" mb="md">
        <Text fw={700}>Dashboard Modülleri</Text>
        <Group>
          <Button size="xs" variant="light" onClick={fetchApps}>
            Yenile
          </Button>
          <Button size="xs" color="violet" leftSection={<IconPlus size={14} />} onClick={openNewApp}>
            Yeni Modül Ekle
          </Button>
        </Group>
      </Group>

      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Sıra</Table.Th>
            <Table.Th>Başlık</Table.Th>
            <Table.Th>İkon & Renk</Table.Th>
            <Table.Th>Rota (Path)</Table.Th>
            <Table.Th>Erişim</Table.Th>
            <Table.Th>Durum</Table.Th>
            <Table.Th style={{ textAlign: 'right' }}>İşlem</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {apps.map((app) => (
            <Table.Tr key={app.id}>
              <Table.Td>{app.order}</Table.Td>
              <Table.Td>
                <Text fw={500}>{app.title}</Text>
                <Text size="xs" c="dimmed">{app.description}</Text>
              </Table.Td>
              <Table.Td>
                <Badge color={app.color} variant="light">{app.icon}</Badge>
              </Table.Td>
              <Table.Td>
                <Text size="sm">{app.path}</Text>
              </Table.Td>
              <Table.Td>
                <Badge color="gray" variant="outline">
                  {app.allowed_roles?.join(', ')}
                </Badge>
              </Table.Td>
              <Table.Td>
                {app.coming_soon ? <Badge color="yellow">Yakında</Badge> : <Badge color="green">Aktif</Badge>}
              </Table.Td>
              <Table.Td style={{ textAlign: 'right' }}>
                <Group gap="xs" justify="flex-end">
                  <ActionIcon color="blue" variant="subtle" onClick={() => openEditApp(app)}>
                    <IconEdit size={16} />
                  </ActionIcon>
                  <ActionIcon color="red" variant="subtle" onClick={() => handleDeleteApp(app.id)}>
                    <IconTrash size={16} />
                  </ActionIcon>
                </Group>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}